import React from 'react';
import { Transaction, TagMap } from '../types';
import TransactionCard from './TransactionCard';

interface TransactionWithNarrationProps {
  transaction: Transaction;
  tagMap: TagMap;
  onTagClick?: (transaction: Transaction, event: React.MouseEvent) => void;
  disableBottomMargin?: boolean;
}

const TransactionWithNarration: React.FC<TransactionWithNarrationProps> = ({
  transaction,
  tagMap,
  onTagClick,
  disableBottomMargin = false,
}) => {
  return (
    <div className={`rounded-xl shadow overflow-hidden bg-muted p-1 flex-shrink-0 dark:bg-input/70 ${disableBottomMargin ? '' : 'mb-4'}`}>
      <TransactionCard transaction={transaction} tagMap={tagMap} onTagClick={onTagClick} className="border border-border rounded-xl shadow" />
      {transaction.description && (
        <div className="bg-transparent p-2 mt-1 rounded-b-lg">
          <div className="flex justify-between items-start">
            <p className="text-xs text-muted-foreground mr-2 break-all [overflow-wrap:anywhere]">
              <span className="font-medium text-secondary-foreground">Narration:</span> {transaction.description}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionWithNarration; 
